const Path = {
  Slash: '/',
  Account: '/account',
  Index: '/index',
  Auth: '/auth',
  Activity: '/activity',
  Transaction: '/transaction',
  TransactionEntry: '/transaction/entry',
  TrialBalance: '/trial-balance',
  BooksOfAccounts: '/books-of-accounts',
  Users: '/users'
};

export default Path;
